import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CheckRole, isLoggedIn } from "../../Services/AuthService";

const MenuList = ({ items, onNavigate, onLogout, variant = "desktop" }) => {
  const loggedIn = isLoggedIn();

  return (
    <>
      {items.map((item, index) => {
        // auth check
        if (item.auth.length === 1) {
          if (item.auth[0] === "auth" && !loggedIn) return null;
          if (item.auth[0] === "guest" && loggedIn) return null;
        }

        // Divider
        if (item.type === "divider") {
          if (item.roles && !CheckRole(item.roles)) return null;
          return (
            <div key={`divider-${index}`} className="dropdown-divider"></div>
          );
        }

        // Roles check
        if (item.roles && !CheckRole(item.roles)) return null;

        // Logout
        if (item.onClick === "logout") {
          return (
            <button
              key={`logout-${index}`}
              className={
                variant === "mobile"
                  ? "menu-item logout"
                  : "dropdown-menu-item logout"
              }
              onClick={onLogout}
            >
              <FontAwesomeIcon
                icon={item.icon}
                className={variant === "mobile" ? "menu-icon" : "dropdown-icon"}
              />
              <span
                className={variant === "mobile" ? "menu-text" : "dropdown-text"}
              >
                {item.label}
              </span>
            </button>
          );
        }

        // Normal item
        return (
          <button
            key={`item-${index}`}
            className={
              variant === "mobile" ? "menu-item" : "dropdown-menu-item"
            }
            onClick={() => onNavigate(item.path, item.state || null)}
          >
            <FontAwesomeIcon
              icon={item.icon}
              className={variant === "mobile" ? "menu-icon" : "dropdown-icon"}
            />
            <span
              className={variant === "mobile" ? "menu-text" : "dropdown-text"}
            >
              {item.label}
            </span>
          </button>
        );
      })}
    </>
  );
};

export default MenuList;
